import { FirearmPartDto } from '../models/firearm'

const MAX_TILES = 6

function formatCurrency (value: number) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value)
}

interface Props {
  parts: FirearmPartDto[];
}

export default function PartsCornerOverlay ({ parts }: Props) {
  if (!parts?.length) return null

  const visible = parts.slice(0, MAX_TILES)
  const remaining = parts.length - visible.length

  return (
    <div className="parts-corner-overlay" aria-label="Attached parts">
      <div className="parts-corner-overlay__grid">
        {visible.map((part) => (
          <div key={part.id} className="parts-corner-tile" title={part.name}>
            {part.imageUrl
              ? (
              <img
                src={part.imageUrl}
                alt=""
                className="parts-corner-tile__img"
              />
                )
              : (
              <>
                <span className="parts-corner-tile__name">{part.name}</span>
                {part.value != null && part.value > 0 && (
                  <span className="parts-corner-tile__value">{formatCurrency(part.value)}</span>
                )}
              </>
                )}
          </div>
        ))}
        {remaining > 0 && (
          <div className="parts-corner-tile parts-corner-tile--more" title={`${remaining} more parts`}>
            +{remaining}
          </div>
        )}
      </div>
    </div>
  )
}
